const talks = [
    {
        title: "Who’s watching your period?",
        type: 'Panel',
        date: 'March 2025',
        venue: 'CPDP Data Protection Day, European Commission (Brussels, Belgium)',
        recording: 'https://www.edps.europa.eu/press-publications/press-news/videos/cpdp-dpd-2025-whos-watching-your-period_en'
    },
    {
        title: 'Designing for Privacy, Safety, and Trust in Mobile Health Apps',
        type: 'Workshop',
        date: 'July 2024',
        venue: 'The 24th Privacy Enhancing Technologies Symposium (Bristol, UK)',
    },
    {
        title: 'Evaluating the Privacy Practices of FemTech Apps',
        type: 'Talk',
        date: 'April 2024',
        venue: 'University of Northumbria (Newcastle, UK)',
    },
    {
        title: 'Measuring Health Misinformation on Social Media',
        type: 'Talk',
        date: 'August 2023',
        venue: 'The 2023 INTERACT Conference (York, UK)',
    }
]

export default talks;